import { isPhoneOrHighScreen } from '@/utilities/sizeUtils';
import { Tooltip } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Fade from '@mui/material/Fade';
import { SelectionType } from './SelectorTypes';

export default function SelectionText({
  selectionState,
  rowCount,
  selectedCount,
  maxElementcount,
}: {
  selectionState?: SelectionType;
  rowCount: number;
  selectedCount?: number;
  maxElementcount?: number;
}) {
  const { t } = useTranslation();
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const showTooltip = () => {
    setTooltipOpen(true);
    setTimeout(() => setTooltipOpen(false), 4000);
  };

  function MaxElementNumber({ maxElementcount }: { maxElementcount: number }) {
    if (isPhoneOrHighScreen()) {
      // controlled
      return (
        <Tooltip
          title={t('filter.maxSelection', { max: maxElementcount })}
          open={tooltipOpen}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          slots={{
            transition: Fade,
          }}
          slotProps={{
            transition: {
              timeout: 1000,
            },
          }}
        >
          <span className="important" onClick={showTooltip} data-qa-element-id="max_selection_count">
            {maxElementcount}*{' '}
          </span>
        </Tooltip>
      );
    }
    // uncontrolled
    return (
      <Tooltip
        title={t('filter.maxSelection', { max: maxElementcount })}
        slots={{
          transition: Fade,
        }}
        slotProps={{
          transition: {
            timeout: 1000,
          },
        }}
      >
        <span className="important" data-qa-element-id="max_selection_count">
          {maxElementcount}*{' '}
        </span>
      </Tooltip>
    );
  }

  function getAll(rowCount: number, maxElementcount: number) {
    if (rowCount == 0) {
      return <span data-qa-element-id="selectable_target_count">(0)</span>;
    }
    if (rowCount < maxElementcount) {
      return <span data-qa-element-id="selectable_target_count">({rowCount})</span>;
    }
    return (
      <span>
        <span data-qa-element-id="selectable_target_count">{rowCount}</span>/
        <MaxElementNumber maxElementcount={maxElementcount} />
        <span data-qa-element-id="selection_label">{t('filter.selection')}</span>
      </span>
    );
  }

  function getSelected(selectedCount: number) {
    return <span data-qa-element-id="selected_target_count">({selectedCount})</span>;
  }

  function getSingleSelect(maxElementcount: number) {
    return <span data-qa-element-id="single_target_selection_count">({maxElementcount})</span>;
  }

  switch (selectionState) {
    case 'all': {
      if (!maxElementcount) return;
      return getAll(rowCount, maxElementcount);
    }
    case 'selected': {
      if (!selectedCount) return;
      return getSelected(selectedCount);
    }
    case 'single-select':
      return getSingleSelect(rowCount);
  }
}
